import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { baseurl } from "../baseurl";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const location = useLocation();
  const customerId = localStorage.getItem("customerId");

  const fetchCartCount = async () => {
    if (!customerId) {
      setCartCount(0);
      return;
    }

    try {
      const res = await axios.get(`${baseurl}getActiveCartByCustomerId/${customerId}`);
      if (res.data.success) {
        // Using total_items from your provided JSON structure
        setCartCount(res.data.items.length);
      }
    } catch (err) {
      console.error("Error fetching cart count:", err);
    }
  };

  // Re-fetch count every time the URL/Route changes
  useEffect(() => {
    fetchCartCount();
  }, [location.pathname, customerId]);

  return (
    <CartContext.Provider value={{ cartCount, fetchCartCount }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);